var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8771 31.7542C24.6458 31.7542 31.7542 24.6458 31.7542 15.8771C31.7542 7.10842 24.6458 0 15.8771 0C7.10842 0 0 7.10842 0 15.8771C0 24.6458 7.10842 31.7542 15.8771 31.7542Z",
    fill: "#FFDD67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79084 16.1947C11.2523 16.1947 12.437 15.01 12.437 13.5485C12.437 12.0871 11.2523 10.9023 9.79084 10.9023C8.32939 10.9023 7.14465 12.0871 7.14465 13.5485C7.14465 15.01 8.32939 16.1947 9.79084 16.1947Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9633 16.1947C23.4248 16.1947 24.6095 15.01 24.6095 13.5485C24.6095 12.0871 23.4248 10.9023 21.9633 10.9023C20.5019 10.9023 19.3171 12.0871 19.3171 13.5485C19.3171 15.01 20.5019 16.1947 21.9633 16.1947Z",
    fill: "#664E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5289 24.345H12.2254C11.4315 24.345 11.4315 22.228 12.2254 22.228H19.4759C20.3227 22.228 20.3227 24.345 19.5289 24.345Z",
    fill: "#664E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji2);
export default __webpack_public_path__ + "static/media/emoji2.f4f6f327ebe014fb960bf0873e33bdd3.svg";
export { ForwardRef as ReactComponent };